export const locales = [
  {
    code: 'ca-ES',
    name: 'languages.catalan'
  },
  {
    code: 'ca-AD',
    name: 'languages.andorra'
  },
  {
    code: 'es-AR',
    name: 'languages.argentina'
  },
  {
    code: 'es-CL',
    name: 'languages.chile'
  },
  {
    code: 'es-CO',
    name: 'languages.colombia'
  },
  {
    code: 'es-ES',
    name: 'languages.spanish'
  },
  {
    code: 'es-MX',
    name: 'languages.mexico'
  },
  {
    code: 'en-US',
    name: 'languages.english'
  },
  {
    code: 'eu-ES',
    name: 'languages.basque'
  },
  {
    code: 'fr-FR',
    name: 'languages.français'
  },
  {
    code: 'it-IT',
    name: 'languages.italian'
  }
]

export const codes = locales.map(item => item.code)
export const defaultLocale = {
  code: 'en-US',
  name: 'English'
}

export const parseLocale = someString => {
  const normalized = someString.toLowerCase().replace('_', '-')
  return locales.filter(item => item.code.toLowerCase().startsWith(normalized))[0]
}

export const selectLocales = [
  {
    'text': 'languages.spanish',
    'value': 'es-ES'
  },
  {
    'text': 'languages.english',
    'value': 'en-US'
  },
  {
    'text': 'languages.andorra',
    'value': 'ca-AD'
  },
  {
    'text': 'languages.catalan',
    'value': 'ca-ES'
  },
  {
    'text': 'languages.basque',
    'value': 'eu-ES'
  },
  {
    'text': 'languages.colombia',
    'value': 'es-CO'
  },
  {
    'text': 'languages.chile',
    'value': 'es-CL'
  },
  {
    'text': 'languages.argentina',
    'value': 'es-AR'
  },
  {
    'text': 'languages.mexico',
    'value': 'es-MX'
  },
  {
    'text': 'languages.italian',
    'value': 'it-IT'
  },
  {
    'text': 'languages.french',
    'value': 'fr-FR'
  }]
export default {
  locales,
  codes,
  parseLocale,
  defaultLocale
}
